import React from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import CheckBox from './CheckBox';
import RegistrationSettingMessageBox from './RegistrationSettingMessageBox';
import AttendanceClassSettingMessageBox from './AttendanceClassSettingMessageBox';
import ExpiredSettingMessageBox from './ExpiredSettingMessageBox';

export default function AutoMessageSettingBox(props) {
  const {
    isClickedTotalSetting,
    onClickUseSettingBox,
    registration,
    setRegistration,
    attendanceClass,
    setAttendanceClass,
    expired,
    setExpired,
    onClickEditText,
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <MessageBoxWrapper>
      {/* <TotalUseSettingWrapper>
        <TotalUseSettingBox
          isClicked={isClickedTotalSetting}
          onClick={onClickUseSettingBox}>
          <CheckBox
            isClicked={isClickedTotalSetting}
            onClickCheckBox={onClickUseSettingBox}
            boxWidth={15}
            boxHeight={15}
            boxRadius={5}
            imageWidth={10}
            imageHeight={7} />
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isClickedTotalSetting ? theme.primary : theme.text} hover='pointer'>{t('messageSend.autoMessage.useSettingLabel')}</Text>
        </TotalUseSettingBox>
        <TotalUseTextWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={10} color={theme.subText} hover='default'>{t('messageSend.autoMessage.useSettingDesc1')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={10} color={theme.subText} hover='default'>{t('messageSend.autoMessage.useSettingDesc2')}</Text>
        </TotalUseTextWrapper>
      </TotalUseSettingWrapper> */}
      <DivisionSettingBoxWrapper>
        <RegistrationSettingMessageBox
          isActivate={isClickedTotalSetting}
          registration={registration}
          setRegistration={setRegistration}
          onClickEdit={onClickEditText} />

        <AttendanceClassSettingMessageBox
          isActivate={isClickedTotalSetting}
          attendanceClass={attendanceClass}
          setAttendanceClass={setAttendanceClass}
          onClickEdit={onClickEditText} />

        <ExpiredSettingMessageBox
          isActivate={isClickedTotalSetting}
          expired={expired}
          setExpired={setExpired}
          onClickEdit={onClickEditText} />
      </DivisionSettingBoxWrapper>
    </MessageBoxWrapper>
  )
}

const MessageBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 16px;

  width: 1035px;
`;

const TotalUseSettingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  gap: 10px;
`;

const TotalUseSettingBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;

  height: 50px;

  gap: 10px;

  border-radius: 10px;
  background-color: ${props => props.isClicked ? `${props.theme.primaryAlpha20}` : `${props.theme.subBackground}`};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const TotalUseTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const DivisionSettingBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 40px;

  width: 100%;

  gap: 30px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }
`;
